import { Labelled } from './generic';

export interface Tab<T> extends Labelled<T> {}

export enum PlayerDataLockerTabValue {
  GENERAL = 'general',
  PLAYER = 'player',
  METRICS = 'metrics',
}

export enum DataLockerSelectedTab {
  PLAYER = 'players',
  TEAM = 'teams',
  EVENTS = 'events',
}

export enum RadarTemplateModalTab {
  AVAILABLE_METRICS = 'available-metrics',
  SELECTED_METRICS = 'selected-metrics',
}

export enum ComparisonFilterTab {
  PRIMARY = 'primary',
  COMPARISON = 'comparison',
}

export enum PreviewTab {
  PRIMARY = 'primaryPreview',
  COMPARISON = 'comparisonPreview',
}
